module.exports = {
  all: {
    key: 'all',
    name: 'All',
  },
  ott: {
    key: 'ott',
    name: 'OTT',
  },
  advertising: {
    key: 'advertising',
    name: 'Advertising',
  },
  sports: {
    key: 'sports',
    name: 'Sports',
  },
  promotion: {
    key: 'promotion',
    name: 'Promotion',
  },
};
